
export default {
  tncWrap: {
    'z-index': '1',
    bottom: '65px',
    width: '100vw',
  },
  tnc: {
    width: '300px',
    'max-width': '80vw',
    color: 'rgba(0,0,0,0.5)',
    margin: '0 auto',
    'text-align': 'center',
  },
  tncLink: {
    color: '#D5AD40',
    opacity: '0.9',
  },
  fixed: {
    position: 'fixed',
  },
  'takeaway-order-detail-list-wrap': {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    margin: '15px 15px 20px 15px',
    padding: '20px 20px 20px 25px',
    borderRadius: 15,
    background: '#fff',
    boxShadow: '0 4px 17px 0 rgba(160, 156, 156, 0.36)',
    '& > div:nth-child(2)': {
      'border-bottom': 'none !important',
      'padding-bottom': '0 !important',
    },
  },
  header: {
    color: '#A59996',
  },
  'total-item-title': {
    'margin-top': '5px',
  },
  'item-price-prefix': {
    'font-size': '13px',
    'vertical-align': 'middle',
    height: '22px',
    'margin-right': '1px',
  },
  'item-price': {
    'font-size': '20px',
    color: '#a91d1d',
    'font-weight': 'bold',
    'margin-left': '2px',
    display: 'inline-block',
  },
  'item-price-disabled': {
    color: '#aaa',
    'margin-left': '2px',
    display: 'inline-block',
  },
  'collapse-toggle': {
    background: '#614D4A',
    width: '53px',
    height: '25px',
    paddingLeft: '5px',
    paddingRight: '5px',
    color: '#fff',
    textAlign: 'center',
    'border-top-left-radius': '12.5px',
    'border-bottom-left-radius': '12.5px',
    'border-top-right-radius': '12.5px',
    'border-bottom-right-radius': '12.5px',
    lineHeight: '25px',
  },
  'collapse-toggle-wrap': {
    position: 'absolute',
    width: '100%',
    left: 0,
    bottom: '-12.5px',
    textAlign: 'center',
  },
  'expand-toggle-wrap': {
    position: 'relative',
    bottom: '25px',
    width: '100%',
    textAlign: 'center',
  },
  'discounted-item-original-price': {
    'font-size': '15px',
    color: '#a7a7a7',
    'text-decoration': 'line-through',
    display: 'inline-block',
    'margin-right': '5px',
  },
  'takeaway-summary-sub-header': {
    'font-size': '10px',
    color: '#A59996',
    'margin-top': '10px',
    'margin-bottom': '5px',
  },
  'promo-code-span': {
    flexShrink: 0,
    whiteSpace: 'pre',
  },
  'promo-code-input': {
    flex: 1,
    width: '100%',
    borderRadius: 5,
    margin: '0 8px',
    padding: 8,
    border: '1px solid #d8d8d8',
  },
  'promo-code-button': {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    padding: '10px 15px',
    borderRadius: '30px',
  },
  'promo-code-cancel': {
    background: '#4a8ca1',
  },
  'promo-code-submit-enabled': {
    background: '#4a8ca1',
  },
  'promo-code-submit-disabled': {
    background: '#D8D8D8',
  },
  'payment-mathod-span': {
    position: 'absolute',
    right: '16px',
    bottom: '16px',
    textAlign: 'right',
  },
  'shipping-fee-wrap': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  'shipping-detail-wrap': {
    color: '#aaa',
    lineHeight: 'normal',
    width: '100%',
    paddingTop: 10,
    margin: 16,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: '#D8D8D8',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/TakeawayOrderDetailList.js